import React from "react";
import { Icon } from "@alm/flow-ds/components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function TaskComplete() {
	const { t } = useTranslation();
	return (
		<div style={{ margin: "5rem auto", textAlign: "center" }}>
			<span style={{ color: "green" }}>
				<Icon type="check-circle" weight="d" className="fa-5x mb-3" />
			</span>
			<p className="lead">{t("main.activities.taskComplete")}</p>
			<Link to="/" className="btn btn-link mt-3">
				{t("main.activities.taskCompleteBackLinkText")}
			</Link>
		</div>
	);
}

export default React.memo(TaskComplete);
